export enum NEWS_TYPES {
  GROUP_AND_TEAM = 'GroupAndTeam',
  USER_ROLE = 'UserRole',
  ALL_EMPLOYEES = 'AllEmployees',
}
